import { NgModule } from '@angular/core';
import { ExtraFieldValidatonService } from '../shared/services/extra-field-validaton.service';
import { CartResumeService } from '../shared/services/cart-resume.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreConfigurationsService } from '../shared/services/store-configurations.service';
import {
    TranslateLoader,
    TranslateModule,
    TranslateService
} from '@ngx-translate/core';
import { AppComponent } from '../app.component';
import { CookieOptions, CookieService } from 'angular2-cookie/core';
import { BootstrapModalModule } from 'ngx-modialog/plugins/bootstrap';
import { HttpModule } from '@angular/http';
import { ResponsiveModule } from 'ng2-responsive';
import { CommonHttpService } from '../shared/services/http.service';
import { IdentificationStepsService } from './services/identification-steps.service';
import { NgxMaskModule } from 'ngx-mask';
import { ExtraFieldValidationRuleService } from '../shared/services/extra-field-validation-rule.service';
import { FreightCalculatorService } from '../shared/services/freight-calculator.service';
import { CartItemsService } from '../shared/services/cart-items.service';
import { MobileScrollToService } from '../shared/services/mobile-scroll-to.service';
import { PaymentService } from './services/payment.service';
import { HttpClientModule } from '@angular/common/http';
import { DeliveryStepsService } from './services/delivery-steps.service';
import { PasswordRecoveryStepsService } from './services/password-recovery-steps.service';
import { ModalModule } from 'ngx-modialog';
import { ToastrModule } from 'ngx-toastr';
import { CustomFormsModule } from 'ng2-validation';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '../app-routing.module';
import { CartRowsUpdaterService } from '../cart/services/cart-rows-updater.service';
import { UnauthenticatedUserRepositoryService } from './services/unauthenticated-user-repository.service';
import { ResumeUpdaterService } from '../cart/services/cart-resume-updater.service';
import { OauthService } from '../shared/services/oauth.service';
import { BrowserModule } from '@angular/platform-browser';
import { DistanceToDeadlineService } from './services/distance-to-deadline.service';
import { CommonModule } from '@angular/common';
import { PaymentStepsService } from './services/payment-steps.service';
import { AuthenticatedUserRepositoryService } from './services/authenticated-user-repository.service';
import { OverlayModule } from 'angular-io-overlay/src/overlay';
import { PaymentIdentificationHeaderComponent } from './identification/header/payment.identification.header.component';
import { PaymentExtraFieldsComponent } from './extra-fields/payment.extra-fields.component';
import { PaymentResumeComponent } from './resume/payment.resume.component';
import { PaymentDeliveryFreightsFreightItemComponent } from './delivery/freights/freight-item/payment.delivery.freights.freight-item.component';
import { PaymentDeliveryFreightsFreightItemScheduleComponent } from './delivery/freights/freight-item/schedule/payment.delivery.freights.freight-item.schedule.component';
import { PaymentPaymentOptionPaymentOnShippingComponent } from './payment/option/payment-on-shipping/payment.payment.option.payment-on-shipping.component';
import { PaymentDeliveryAddressesAddressItemComponent } from './delivery/addresses/address-item/payment.delivery.addresses.address-item.component';
import { PaymentResumeRowComponent } from './resume/row/payment.resume.row.component';
import { PaymentDeliveryFreightsReadyComponent } from './delivery/freights/ready/payment.delivery.freights.ready.component';
import { PaymentPaymentOptionCardComponent } from './payment/option/card/payment.payment.option.card.component';
import { PaymentDeliveryFreightsComponent } from './delivery/freights/payment.delivery.freights.component';
import { PaymentIdentificationExistentEmailComponent } from './identification/existent-email/payment.identification.existent-email.component';
import { PaymentDeliveryAddressesReadyComponent } from './delivery/addresses/ready/payment.delivery.addresses.ready.component';
import { PaymentDeliveryComponent } from './delivery/payment.delivery.component';
import { PaymentDeliveryAddressesComponent } from './delivery/addresses/payment.delivery.addresses.component';
import { PaymentResumePayButtonComponent } from './resume/pay-button/payment.resume.pay-button.component';
import { PaymentIdentificationIdentificationComponent } from './identification/identification/payment.identification.identification.component';
import { PaymentDeliveryAddressesListComponent } from './delivery/addresses/list/payment-delivery-addresses-list.component';
import { PaymentPaymentOptionComponent } from './payment/option/payment.payment.option.component';
import { PaymentIdentificationPasswordRecoveryReceiveTokenComponent } from './identification/password-recovery/receive-token/payment.identification.password-recovery.receive-token.component';
import { PaymentIdentificationPasswordRecoveryCreatePasswordComponent } from './identification/password-recovery/create-password/payment.identification.password-recovery.create-password.component';
import { PaymentPaymentOptionBankSlipComponent } from './payment/option/bank-slip/payment.payment.option.bank-slip.component';
import { PaymentDeliveryFreightsListComponent } from './delivery/freights/list/payment.delivery.freights.list.component';
import { PaymentIdentificationNewUserComponent } from './identification/new-user/payment.identification.new-user.component';
import { PaymentIdentificationPasswordRecoveryComponent } from './identification/password-recovery/payment.identification.password-recovery.component';
import { PaymentPaymentOptionCardItemComponent } from './payment/option/card/option/item/payment.payment.option.card.item.component';
import { PaymentIdentificationComponent } from './identification/payment.identification.component';
import { PaymentPaymentOptionCardFormComponent } from './payment/option/card/option/form/payment.payment.option.card.form.component';
import { PaymentPaymentOptionNonTransparentCheckoutComponent } from './payment/option/non-transparent-checkout/payment.payment.option.non-transparent-checkout.component';
import { PaymentIdentificationIdentifiedUserComponent } from './identification/identified-user/payment.identification.identified-user.component';
import { PaymentDeliveryAddressesZipCodeComponent } from './delivery/addresses/zip-code/payment.delivery.zip-code.component';
import { PaymentDeliveryAddressesAddressNewComponent } from './delivery/addresses/address-new/payment.delivery.addresses.address-new.component';
import { PaymentIdentificationPasswordRecoveryChooseContinueMethodComponent } from './identification/password-recovery/choose-continue-method/payment.identification.password-recovery.choose-continue-method.component';
import { PaymentIdentificationReadyComponent } from './identification/ready/payment.identification.ready.component';
import { PaymentPaymentComponent } from './payment/payment.payment.component';
import { PaymentPaymentOptionCardOptionComponent } from './payment/option/card/option/payment.payment.option.card.option.component';
import { PaymentComponent } from './payment.component';
import { PaymentAddressFormComponent } from './address-form/payment.address-form.component';
import { SectionPlaceholderComponent } from './section-placeholder/section-placeholder.component';
import { ExtraFieldsListComponent } from '../shared/components/extra-fields-list/extra-fields-list.component';
import { ExtraFieldsListItemComponent } from '../shared/components/extra-fields-list/item/extra-fields-list.item.component';
import { FormboxHeaderComponent } from './formbox-header/payment-formbox-header.component';
import { LoaderModule } from '../shared/components/loader/loader.module';
import { ValidatorsModule } from '../shared/validators/validators.module';
import { AutofocusDirective } from '../shared/directives/autofocus.directive';
import { ThumbSourceFactoryService } from '../shared/services/thumb-source-factory.service';
import { PaymentPaymentCouponComponent } from './payment/coupon/payment.payment.coupon.component';
import { TextMaskModule } from 'angular2-text-mask';
import { GoogleAnalyticsService } from '../shared/services/google-analytics.service';
import { GoogleConversionTagModule } from '../shared/components/google-conversion-tag/google-conversion-tag.module';
import { SocialLoginButtonFacebookModule } from '../shared/components/social-login-button/facebook/social-login-button.facebook.module';
import { SocialLoginButtonGoogleModule } from '../shared/components/social-login-button/google/social-login-button.google.module';
import { PaymentResumeCartRecurrentComponent } from './resume/cart-recurrent/payment.resume.cart-recurrent.component';
import { PaymentPaymentOptionCardFormDefaultComponent } from './payment/option/card/option/form/default/payment.payment.option.card.form.default.component';
import { PaymentPaymentOptionCardFormMercadoPagoComponent } from './payment/option/card/option/form/mercado-pago/payment.payment.option.card.form.mercado-pago.component';
import { PaymentPaymentOptionCardFormBspagComponent } from './payment/option/card/option/form/bspag/payment.payment.option.card.form.bspag.component';
import { PaymentPaymentOptionCardFormCieloComponent } from './payment/option/card/option/form/cielo/payment.payment.option.card.form.cielo.component';
import { CardInputsModule } from '../card-inputs/card-inputs.module';
import { ScriptHackModule } from '../shared/components/script-hack/script-hack.module';
import { MyDatePickerModule } from 'mydatepicker';
import { SchedulingSettingsDatepickerService } from './services/scheduling-settings-datepicker.service';
import { ScheduleService } from './services/schedule.service';
import { LocaleService as MyDatePickerLocaleService } from 'mydatepicker/dist';
import { WebpackTranslateLoader } from '../webpack-translate-loader';
import { CreditCardDirectivesModule } from 'ng-betalabs-creditcard';
import { FacebookService } from '../shared/services/facebook.service';
import { DataLayerModule } from '../shared/data-layer/data-layer.module';
import { RecaptchaModule } from 'ng-recaptcha';
import { PaymentPaymentOptionPixComponent } from './payment/option/pix/payment.payment.option.pix.component';
import { TranslationConfiguratorService } from '../shared/services/translation-configurator.service';
import { LocaleProvider } from '../shared/services/locale.service';
import { PaymentPaymentOptionCardOptionListComponent } from './payment/option/card/option/list/payment.payment.option.card.option.list.component';
import { PaymentResumePayButtonButtonElementComponent } from './resume/pay-button/button-element/payment.resume.pay-button.button-element.component';
import { PaymentResumePayButtonRecaptchaComponent } from './resume/pay-button/recaptcha/payment.resume.pay-button.recaptcha.component';
import { CaptchaService } from './services/captcha.service';
import { PaymentPaymentOptionCardFormPagSeguroComponent } from './payment/option/card/option/form/pagseguro/payment.payment.option.card.form.pagseguro.component';
import { CurrencyMaskModule } from 'ngx-currency-mask';
import { PaymentPaymentOptionCardOptionMultipleCardsInstallmentsComponent } from './payment/option/card/option/multiple-cards-installments/payment.payment.option.card.option.multiple-cards-installments.component';
import { PaymentResumePayButtonContractsComponent } from './resume/pay-button/contracts/payment.resume.pay-button.contracts.component';
import { PaymentResumeRowComponentsComponent } from './resume/row/components/payment.resume.row.components.component';

@NgModule({
    declarations: [
        SectionPlaceholderComponent,
        ExtraFieldsListComponent,
        ExtraFieldsListItemComponent,
        FormboxHeaderComponent,
        PaymentComponent,
        PaymentAddressFormComponent,
        // Payment delivery
        PaymentDeliveryComponent,
        PaymentDeliveryAddressesReadyComponent,
        PaymentDeliveryAddressesComponent,
        PaymentDeliveryAddressesListComponent,
        PaymentDeliveryAddressesZipCodeComponent,
        PaymentDeliveryAddressesAddressNewComponent,
        PaymentDeliveryAddressesAddressItemComponent,
        PaymentDeliveryFreightsComponent,
        PaymentDeliveryFreightsListComponent,
        PaymentDeliveryFreightsReadyComponent,
        PaymentDeliveryFreightsFreightItemComponent,
        PaymentDeliveryFreightsFreightItemScheduleComponent,
        // Payment resume
        PaymentResumeComponent,
        PaymentResumeRowComponent,
        PaymentResumePayButtonComponent,
        PaymentResumePayButtonButtonElementComponent,
        PaymentResumePayButtonRecaptchaComponent,
        PaymentResumePayButtonContractsComponent,
        PaymentResumeCartRecurrentComponent,
        PaymentResumeRowComponentsComponent,
        // Payment payment
        PaymentPaymentComponent,
        PaymentPaymentCouponComponent,
        PaymentPaymentOptionComponent,
        PaymentPaymentOptionCardComponent,
        PaymentPaymentOptionCardItemComponent,
        PaymentPaymentOptionCardOptionComponent,
        PaymentPaymentOptionCardOptionListComponent,
        PaymentPaymentOptionCardFormComponent,
        PaymentPaymentOptionCardFormDefaultComponent,
        PaymentPaymentOptionCardFormMercadoPagoComponent,
        PaymentPaymentOptionCardFormBspagComponent,
        PaymentPaymentOptionCardFormCieloComponent,
        PaymentPaymentOptionCardFormPagSeguroComponent,
        PaymentPaymentOptionCardOptionMultipleCardsInstallmentsComponent,
        PaymentPaymentOptionBankSlipComponent,
        PaymentPaymentOptionPaymentOnShippingComponent,
        PaymentPaymentOptionNonTransparentCheckoutComponent,
        PaymentPaymentOptionPixComponent,
        // Payment identification
        PaymentIdentificationComponent,
        PaymentIdentificationHeaderComponent,
        PaymentIdentificationReadyComponent,
        PaymentIdentificationNewUserComponent,
        PaymentIdentificationExistentEmailComponent,
        PaymentIdentificationIdentifiedUserComponent,
        PaymentIdentificationIdentificationComponent,
        PaymentIdentificationPasswordRecoveryComponent,
        PaymentIdentificationPasswordRecoveryReceiveTokenComponent,
        PaymentIdentificationPasswordRecoveryCreatePasswordComponent,
        PaymentIdentificationPasswordRecoveryChooseContinueMethodComponent,
        // Payment extra fields
        PaymentExtraFieldsComponent,
        // directives
        AutofocusDirective
    ],
    imports: [
        ValidatorsModule,
        LoaderModule,
        BrowserModule,
        CommonModule,
        HttpModule,
        HttpClientModule,
        FormsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: WebpackTranslateLoader
            }
        }),
        ReactiveFormsModule,
        NgxMaskModule,
        AppRoutingModule,
        OverlayModule,
        CustomFormsModule,
        ResponsiveModule,
        ModalModule.forRoot(),
        BootstrapModalModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 10000,
            positionClass: 'toast-top-full-width',
            preventDuplicates: true
        }),
        TextMaskModule,
        GoogleConversionTagModule,
        SocialLoginButtonFacebookModule,
        SocialLoginButtonGoogleModule,
        CreditCardDirectivesModule,
        CardInputsModule,
        ScriptHackModule,
        MyDatePickerModule,
        DataLayerModule,
        RecaptchaModule.forRoot(),
        CurrencyMaskModule
    ],
    providers: [
        CookieService,
        CommonHttpService,
        OauthService,
        ThumbSourceFactoryService,
        StoreConfigurationsService,
        ExtraFieldValidatonService,
        ExtraFieldValidationRuleService,
        FreightCalculatorService,
        // common services
        CartItemsService,
        CartResumeService,
        MobileScrollToService,
        // cart services
        CartRowsUpdaterService,
        ResumeUpdaterService,
        // payment services
        PaymentStepsService,
        IdentificationStepsService,
        DeliveryStepsService,
        AuthenticatedUserRepositoryService,
        UnauthenticatedUserRepositoryService,
        PasswordRecoveryStepsService,
        PaymentService,
        DistanceToDeadlineService,
        GoogleAnalyticsService,
        StoreConfigurationsService,
        SchedulingSettingsDatepickerService,
        MyDatePickerLocaleService,
        ScheduleService,
        FacebookService,
        CaptchaService,
        LocaleProvider,
        { provide: CookieOptions, useValue: {} }
    ],
    bootstrap: [
        AppComponent
    ],
    exports: [
        TranslateModule
    ]
})
export class PaymentModule {

    constructor(
        public translate: TranslateService
    ) {
        translate.use(
            TranslationConfiguratorService.decideUseLanguage(this.translate.getBrowserLang())
        );
    }

}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/payment/payment.module.ts